// Single source for sport-category checks and the football-first ordering, so
// the `"football"`/`"basketball"` literals and the sort comparator are not
// copy-pasted across selectors (Principle 3 & 6).

export const SPORT_CATEGORY = {
  Football: "football",
  Basketball: "basketball",
  VirtualFootball: "virtual-football",
  VirtualBasketball: "virtual-basketball",
} as const;

export const isFootball = (category?: string): boolean =>
  category === SPORT_CATEGORY.Football;

export const isBasketball = (category?: string): boolean =>
  category === SPORT_CATEGORY.Basketball;

export const isVirtualFootball = (category?: string): boolean =>
  category === SPORT_CATEGORY.VirtualFootball;

export const isVirtualBasketball = (category?: string): boolean =>
  category === SPORT_CATEGORY.VirtualBasketball;

// Either virtual sport — used where a call site treats "any virtual round"
// the same way (single bet-mode row, no bet-time score snapshot), regardless
// of which ball it is.
export const isVirtualSport = (category?: string): boolean =>
  isVirtualFootball(category) || isVirtualBasketball(category);

// Football first (the default sport), everything else keeps its relative order.
export const sortFootballFirst = <T extends { category: string }>(
  sports: T[]
): T[] =>
  [...sports].sort((a, b) =>
    isFootball(a.category) ? -1 : isFootball(b.category) ? 1 : 0
  );
